import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import { ExpenseCashsModel } from "../models/ExpenseCashsModel";
import { ExpenseCashsService } from "src/services/documents/ExpenseCashsService";
import { AppEntities } from "src/config/entities";
import { ExpenseCashsDto } from "../dtos/ExpenseCashsDto";
import { ExpenseCashPaymentDto } from "../dtos/ExpenseCashPaymentDto";

interface IProps {
    documentId?: string;
}

export const useFetchExpenseCash = ({documentId}: IProps) => {
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);
    const [documentDto, setDocumentDto] = useState<ExpenseCashsDto | null>(null);
    const [documentModel, setDocumentModel] = useState<ExpenseCashsModel | null>(null);
    const dataService = AppEntities.ExpenseCashPayments.getDataService() as ExpenseCashsService;

    const postDocument = async () => {
        if (!documentId) return;
        await dataService.PostDocument(documentId);
        toast.success("Document posted successfully");
    }

    const cancelDocument = async () => {
        if (!documentId) return;
        await dataService.CancelDocument(documentId);
        toast.success("Document canceled successfully");
    }
    
    const updateDocument = async (documentModel: ExpenseCashsModel) => {
        if (!documentId) return;
        console.log(documentModel)
        //@ts-ignore
        const requestDto: ExpenseCashsDto = {...documentModel};
        const responseDto = await dataService.Update(requestDto);
        setDocumentDto(responseDto);
        // toast.success("Document updated successfully");
    }

    const fetchDocument = async () => {
        try {
            setIsDocumentLoading(true);

            console.log("documentId", documentId);

            let responseDto: ExpenseCashsDto | null = null;
            let responsePayments: ExpenseCashPaymentDto[] = [];
            if (!documentId) {
                responseDto = await dataService.Create({
                    documentDate: new Date(),
                });
                setDocumentDto(responseDto);
            } else {
                responseDto = await dataService.Get(documentId);
                setDocumentDto(responseDto);
            }
            
            if (!responseDto) return;
            
            const newModel: ExpenseCashsModel = {
                ...responseDto,
                payments: [...responsePayments]
            };
            setDocumentModel(newModel);
        } catch (e) {
            console.log(e);
        } finally {
            setIsDocumentLoading(false);
        }
    }

    useEffect(() => {
        fetchDocument();
    }, [documentId]);

    return {
        isDocumentLoading,
        documentDto,
        documentModel,
        postDocument,
        cancelDocument,
        updateDocument
    }
}